module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.7ad17c6085dee9a33787.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.eot
// module id = 744
// module chunks = 2